import { render } from "./CampusView.vue?vue&type=template&id=460541d2"
import script from "./CampusView.vue?vue&type=script&lang=js"
export * from "./CampusView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__